<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="titolo"
      [placeholder]="'Titolo' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="tipo"
      [placeholder]="'Tipo' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="annoEdizione"
      [placeholder]="'Anno Edizione' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="fondo"
      [placeholder]="'Fondo' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="collocazione"
      [placeholder]="'Collocazione' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="autore"
      [placeholder]="'Autore' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="tag"
      [placeholder]="'Tag' | translate">
  </mat-form-field>
</form>
